import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=07d128cd&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d128cd')) {
      api.createRecord('07d128cd', component.options)
    } else {
      api.reload('07d128cd', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=07d128cd&", function () {
      api.rerender('07d128cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2asVt7o4xF28k/JS/comp/ImgFallback.vue"
export default component.exports